import { FaIcon, ThemeTokens } from '@acp/core-ui';
import { Occupant } from '@acp/shared';
import {
    Button, Checkbox, HStack, Spacer, Text, VStack,
} from '@chakra-ui/react';
import { faAt, faPhone } from '@fortawesome/pro-solid-svg-icons';
import { useFormContext } from 'react-hook-form';
import { SubmitBookingFormSchemaValues } from './form-scheme';

export function OccupantCard({
    occupant, isExistingContact, isPrimaryContact,
    onSelect, onSetPrimaryContact,
}: {
    occupant: Occupant;
    isExistingContact: boolean;
    isPrimaryContact: boolean;
    onSelect: (occupant: Occupant, isChecked: boolean) => void;
    onSetPrimaryContact: (occupant: Occupant) => void;
}) {
    const { watch } = useFormContext<SubmitBookingFormSchemaValues>();
    const { isEnabled } = watch('oasBooking.nominatedContact');
    const isPrimaryStatus = isEnabled ? false : isPrimaryContact;

    const getMobileContact = (occupantData: Occupant) => {
        if (occupantData.mobile !== undefined) {
            return occupant.mobile;
        }
        if ((occupantData.mobileContacts[0].length > 0) && occupant.mobileContacts[0].trim() !== '') {
            return occupant.mobileContacts[0];
        }
        return 'No phone number';
    };

    const mobileContact = getMobileContact(occupant);

    const occupantHasEmail = occupant.email != null && occupant.email.trim() !== '';

    return (
        <VStack
            w="full"
            h="full"
            alignItems="stretch"
            borderColor="muted.50"
            borderWidth={1}
            p={4}
            direction="column"
            minW={250}
            rounded="md"
            shadow="sm"
            cursor="pointer"
            onClick={(e) => {
                e.preventDefault();
                onSelect(occupant, !isExistingContact);
            }}
        >
            <HStack align="left" pb={2} alignItems="flex-start">
                <Text maxW={180} fontWeight="bold">{occupant.name}</Text>
                <Spacer />
                <Checkbox
                    isChecked={isExistingContact}
                    onChange={(e) => {
                        onSelect(occupant, e.target.checked);
                    }}
                />
            </HStack>

            <Spacer />
            <HStack>
                <FaIcon icon={faPhone} color="muted.500" />

                <Text>
                    {mobileContact}
                </Text>
            </HStack>
            <HStack pb={2}>
                <FaIcon icon={faAt} color="muted.500" />
                {(occupantHasEmail === true) && (
                    <Text maxW={200}>{occupant.email}</Text>
                )}
                {(occupantHasEmail === false) && (
                    <Text maxW={200} color="muted.500">
                        Not provided
                    </Text>
                )}
            </HStack>
            <HStack align="left">
                <Button
                    variant="outline"
                    size="xs"
                    fontSize="xs"
                    color={isPrimaryStatus ? 'white' : 'muted.300'}
                    colorScheme="muted"
                    borderColor={ThemeTokens.Defaults.borderColor}
                    bg={isPrimaryStatus ? 'secondary.500' : 'transparent'}
                    _hover={{ opacity: 0.8 }}
                    zIndex={20}
                    position="relative"
                    onClick={(e) => {
                        e.stopPropagation();
                        onSetPrimaryContact(occupant);
                    }}
                >
                    {isPrimaryStatus ? 'Primary contact' : 'Set as primary contact'}
                </Button>
            </HStack>
        </VStack>
    );
}
